import { useEffect, useRef } from "react"

/**
 * Shared infinite-scroll helper for card lists.
 * Table listings should keep numbered Pagination.
 *
 * Observes `sentinelRef` and calls `onLoadMore` when it enters the viewport.
 */
const useInfinitePagination = ({
  hasMore = false,
  isLoading = false,
  onLoadMore,
  enabled = true,
  rootMargin = "200px 0px",
  resetKey,
  sentinelRef: sentinelRefProp,
  rootRef,
} = {}) => {
  const innerRef = useRef(null)
  const sentinelRef = sentinelRefProp || innerRef

  useEffect(() => {
    if (!enabled || !hasMore || isLoading) return undefined
    const node = sentinelRef.current
    if (!node || typeof onLoadMore !== "function") return undefined

    const observer = new IntersectionObserver(
      entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          onLoadMore()
        }
      },
      { root: rootRef?.current || null, rootMargin, threshold: 0 },
    )

    observer.observe(node)
    return () => observer.disconnect()
  }, [
    enabled,
    hasMore,
    isLoading,
    onLoadMore,
    resetKey,
    rootMargin,
    sentinelRef,
    rootRef,
  ])

  return { sentinelRef }
}

export default useInfinitePagination
